import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  QuotationCategory,
  QuotationProduct,
  TemplateList
} from 'src/types/quotation';
import * as thunks from './thunks';

type State = {
  quotationCategories: QuotationCategory[];
  templateList: TemplateList[];
  productOptions: QuotationProduct[]; // for quotation v2
  totalAmount?: number;
};

const initialState: State = {
  quotationCategories: [],
  templateList: [],
  productOptions: [], // for quotation v2
  totalAmount: 0
};

const slice = createSlice({
  name: 'quotations',
  initialState,
  reducers: {
    // for quotation v2
    setProductOptions: (
      state,
      { payload }: PayloadAction<QuotationProduct[]>
    ) => {
      state.productOptions = payload;
    },
    // for quotation v2
    resetProductOptions: (state) => {
      state.productOptions = [];
    },
    setTotalAmount: (state, { payload }: PayloadAction<number | undefined>) => {
      state.totalAmount = payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(
      thunks.getQuotationsCategoriesThunk.fulfilled,
      (state, { payload }) => {
        state.quotationCategories = payload.originalData.categories || [];
      }
    );

    builder.addCase(
      thunks.getTemplateListThunk.fulfilled,
      (state, { payload }) => {
        state.templateList = payload.originalData.data || [];
      }
    );
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
